import React from 'react';

import Event from './Event';
import RoomPlayButton from './RoomPlayButton';

export default (props) => {
  return (
    <>
      <div style={{margin: "0 0 20px 0"}}>
        <div><h4 style={{ margin: "30px 0 0 0" }}>{props.config.name}</h4></div>
        <div><h6 style={{ margin: "0 0 0 0" }}>{props.config.title}</h6></div>
        <RoomPlayButton config={props.config} setVideoSrc={props.setVideoSrc} />
      </div>
      { props.config.events.map( (event, index) => (
        <Event config={event} setVideoSrc={props.setVideoSrc} key={index} />
      ))}
    </>
  );
}
